import { EdgeDeleteChannelRepository } from '@/modules/connect/infra'
import type { DeleteChannel } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeDeleteChannel(): DeleteChannel {
  return new EdgeDeleteChannelRepository(makeSupabaseEdgeHttpClient()).execute
}
